import React, { useEffect, useState } from "react";
import launchIcon from "../../../images/calendar_icon.svg";
import mailIcon from "../../../images/mail_icon.svg";
import phoneIcon from "../../../images/phone_icon.svg";
import sponsorIcon from "../../../images/user_icon.svg";


const AMC_CARD_DETAIL = [
  {
    image: launchIcon,
    text: "Launch Date",
    name: "launch_date"
  },
  {
    image: sponsorIcon,
    text: "Sponsor",
    name: "sponsor"
  },
  {
    image: mailIcon,
    text: "Email",
    name: "email"
  },
  {
    image: phoneIcon,
    text: "Phone",
    nme: "phone"
  }
]

const AmcDetailCard = ({ amc, where }) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    if (window.innerWidth <= 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, []);

  if (
    (isMobile && where === "ABOUT_AMC") ||
    (!isMobile && where === "SIDE_COLUMN")
  ) {
    return (
      <div className="flex-col shadow-normal bg-white rounded amcDetailCardWrapper">

        {AMC_CARD_DETAIL.map((item) => (<div className="w-100 flex-row align-center wrap cardPoint">
          <img src={item.image} alt="" />

          <span className="para-3 cardLabel">{item.text}</span>
          <span className="para-3-bold">{amc[item.name]}</span>
        </div>))}


        <style jsx>
          {`
          
.amcDetailCardWrapper{
  box-sizing:border-box;
  padding:24px 16px;
}    
@media(max-width:1024px){
  .amcDetailCardWrapper{
    padding:24px 0;
  }
}
@media(max-width:768px){
  .amcDetailCardWrapper{
    width: 45%;
    margin-top:24px;
  }
}      
@media(max-width:600px){
  .amcDetailCardWrapper{
    width:85%;
  }
}
@media(max-width:320px){
  .amcDetailCardWrapper{
    width:100%;
  }
}
.cardPoint{
  box-sizing:border-box;
  padding:8px 16px;
}
.cardLabel{
  margin: 0 10px;
}
          `}
        </style>
      </div>
    );
  } else {
    return "";
  }
};
export default AmcDetailCard;
